module.exports = __webpack_public_path__ + "img/76f27d7.gif";